import axios from "axios";
import { getPaymentBaseurl } from "../_helpers";

const { REACT_APP_PAYMENT_API_BASEURL } = process.env;

export const getBundleCourses = () => {
  const currentUrl = window.location.href;
  
  return axios
    .get(`${getPaymentBaseurl(currentUrl, true)}/v2/bundles`)
    .then((response) => response.data)
    .catch((error) => console.log(error));
};
